var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebmngmntRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3974_2632",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#e33745"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3974_2632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.63475 20.5V19.6152L10.577 17.673H4.30775C3.80258 17.673 3.375 17.498 3.025 17.148C2.675 16.798 2.5 16.3704 2.5 15.8652V5.30775C2.5 4.80258 2.675 4.375 3.025 4.025C3.375 3.675 3.80258 3.5 4.30775 3.5H19.6923C20.1974 3.5 20.625 3.675 20.975 4.025C21.325 4.375 21.5 4.80258 21.5 5.30775V15.8652C21.5 16.3704 21.325 16.798 20.975 17.148C20.625 17.498 20.1974 17.673 19.6923 17.673H13.423L15.3652 19.6152V20.5H8.63475ZM4 13.9233H20V5.30775C20 5.23075 19.9679 5.16025 19.9038 5.09625C19.8398 5.03208 19.7693 5 19.6923 5H4.30775C4.23075 5 4.16025 5.03208 4.09625 5.09625C4.03208 5.16025 4 5.23075 4 5.30775V13.9233Z",
    fill: "#e33745"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebmngmntRed);
export default __webpack_public_path__ + "static/media/webmngmntRed.8c004f5f1994e82d14a82acfc9c5f65b.svg";
export { ForwardRef as ReactComponent };